import { useScreenData } from './useScreenData';

export interface RagThresholds {
  greenThreshold: number;
  amberThreshold: number;
}

export const DEFAULT_RAG_THRESHOLDS: RagThresholds = {
  greenThreshold: 80,
  amberThreshold: 50,
};

export function useRagThresholds(): RagThresholds {
  const { settings } = useScreenData('settings');
  return {
    greenThreshold: settings.aiRagThresholds?.greenThreshold ?? DEFAULT_RAG_THRESHOLDS.greenThreshold,
    amberThreshold: settings.aiRagThresholds?.amberThreshold ?? DEFAULT_RAG_THRESHOLDS.amberThreshold,
  };
}

export function getRagAccent(
  score: number,
  thresholds: RagThresholds = DEFAULT_RAG_THRESHOLDS
): 'success' | 'warning' | 'destructive' {
  if (score >= thresholds.greenThreshold) return 'success';
  if (score >= thresholds.amberThreshold) return 'warning';
  return 'destructive';
}
